'use strict'

import './buttons'
import './charts'
import './dialogs'
import './inputs'
import './lists'
import './misc'
import './panels'
import './tabs'

